<template>
    <div class="wrapper">
        <div class="top">
            <img src="../assets/img_bg2.png" alt="" class="top_bg">
        <!--    <img id="aboutBg" src="./guanwang/imgs/img_bg@5x.png" alt="" class="top_bg">
            <img src="./guanwang/imgs/top_bg_3.png" alt="" class="top_bg">
            <img src="./guanwang/imgs/top_bg_4.png" alt="" class="top_bg">-->
            <div class="about_wrap">
                <div class="about_title">关于我们</div>
                <p class="about_text">MOMI主打陌生人语音交友的手机软件，备受年轻人群体喜欢，这儿远离枯燥的交友方式，轻松结识到更多有趣灵魂，体验全新的娱乐交友方式。云集海量高颜值用户，让单调的生活有所改变，孤单的日子不再存在，提高交友的成功机率，扩大交友圈，用声音排解每个孤独日子，音质高清，不卡不掉线。</p>
                <p class="about_text">改变沉闷的社交现状、提高交友成功率、扩大交友圈，众人语音用好听的声音排解孤单。</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "about",
    methods: {},
    data() {
        return {
            prodList: []
        };
    },
    watch: {},
    created() {}
};
</script>

<style lang="scss" scoped>
    .about{
        width: 100%;
        padding-top: 5.365vw;
        transition: all ease .5s;
    }
    .top,.middle,.bottom{
        width: 100%;
        position: relative;
    }

    .top_bg{
        display: block;
        width: 100%;
        height: auto;
        /* margin-top: -1px; */
    }
    .about_wrap{
        position: absolute;
        width: 31.25vw;
        top: 8vw;
        left: 8.6vw;
        color: #fff;
    }

    .about_title{
        font: 500 2.92vw/3vw PingFangSC-Medium, PingFang SC;
        margin-bottom: 2.14vw;
    }

    .about_text{
        font: 500 1.25vw/1.72vw PingFangSC-Regular, PingFang SC;
        margin-bottom: 2vw;
    }

    .loading{
        width: 500px;
        height: 500px;
        margin: 200px auto;
        overflow: hidden;
    }

    .spinner {
        margin: 50px auto;
        width: 90px;
        height: 90px;
        position: relative;
        text-align: center;
        
        -webkit-animation: rotate 2.0s infinite linear;
        animation: rotate 2.0s infinite linear;
    }
        
    .dot1, .dot2 {
        width: 60%;
        height: 60%;
        display: inline-block;
        position: absolute;
        top: 0;
        
        border-radius: 100%;
        
        -webkit-animation: bounce 2.0s infinite ease-in-out;
        animation: bounce 2.0s infinite ease-in-out;
    }

    .dot1{
        background: #f766cc;
    }

    .dot2 {
        top: auto;
        bottom: 0px;
        background-color: #b78dfe;
        -webkit-animation-delay: -1.0s;
        animation-delay: -1.0s;
    }

    .percent{
        width: 100%;
        height: 50px;
        font: 16px/50px PingFangSC-Medium, PingFang SC;
        text-align: center;
        color: #a140ff;
    }
        
    @-webkit-keyframes rotate { 100% { -webkit-transform: rotate(360deg) }}
    @keyframes rotate { 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg) }}
        
    @-webkit-keyframes bounce {
        0%, 100% { -webkit-transform: scale(0.0) }
        50% { -webkit-transform: scale(1.0) }
    }
        
    @keyframes bounce {
        0%, 100% {
            transform: scale(0.0);
            -webkit-transform: scale(0.0);
        } 50% {
            transform: scale(1.0);
            -webkit-transform: scale(1.0);
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/about.vue